module.exports = __webpack_public_path__ + "static/img/partner2_1.fbb62cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/partner2_1.png
// module id = OKwW
// module chunks = 1